export default __webpack_public_path__ + "static/media/CV_DIGITAL.58979e79.pdf";